module.exports = __webpack_public_path__ + "img/page.7461f927.png";